export default __webpack_public_path__ + "static/media/Freebooter's Vest of Grinning Skulls.e50f77b0.jpg";